import { render, staticRenderFns } from "./G2000.vue?vue&type=template&id=4de5a2bd&scoped=true"
import script from "./G2000.vue?vue&type=script&lang=ts"
export * from "./G2000.vue?vue&type=script&lang=ts"
import style0 from "./G2000.vue?vue&type=style&index=0&id=4de5a2bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de5a2bd",
  null
  
)

export default component.exports